import { useUser } from '@adsk/alloy-provider';
import { LinkButton } from '@adsk/alloy-react-button';
import styled from 'styled-components';
import { translate } from '../../../../../helpers';
import { AssigneePicker, AssigneePickerProps, CommonFormField } from '../../../../../components';
import { AssigneeType } from '../../../../../sdk';

const StyledLinkButton = styled(LinkButton)`
  position: absolute;
  right: 15px;
  top: 0;
`;

const AssignToDropDown = ({ onChange, ...restProps }: AssigneePickerProps) => {
  const { user: currentUser } = useUser();

  const onSelectMyActionItems = () => {
    const userWithValue = {
      id: currentUser?.autodeskId ?? '',
      type: AssigneeType.User,
    };
    onChange?.([userWithValue]);
  };

  return (
    <div style={{ position: 'relative' }}>
      <CommonFormField label={translate('rpPlugin.new.assignedTo')}>
        <AssigneePicker {...restProps} onChange={onChange} />
      </CommonFormField>
      <StyledLinkButton onClick={onSelectMyActionItems}>
        {translate('rpPlugin.filter.myActionItems')}
      </StyledLinkButton>
    </div>
  );
};

export default AssignToDropDown;
